import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { AbstractPaginatedTableComponent } from 'finzzle-angular-utils';
import { FicheConfigColumn } from 'projects/fiche-conseil-backoffice/src/app/components/admin-page/admin-fiche/fiche-config-table/fiche-config-columns';
import { AdminConfig } from 'projects/fiche-conseil-backoffice/src/app/services/admin-config.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-fiche-config-table',
  templateUrl: './fiche-config-table.component.html',
  styleUrls: ['./fiche-config-table.component.scss'],
})
export class FicheConfigTableComponent extends AbstractPaginatedTableComponent<AdminConfig> {
  @ViewChildren('configSort') configSortsort: QueryList<MatSort>;

  @Input()
  columnSelection: FicheConfigColumn[] = [];

  @Input()
  displayedColumns: string[];

  @Output()
  onRowClick = new EventEmitter<AdminConfig>();

  sortActive?: string;
  sortDirection?: string;
  sort: MatSort;
  sortSub: Subscription;

  constructor(private datePipe: DatePipe) {
    super();
  }
  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.sortSub?.unsubscribe();
  }
  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.sortSub = this.configSortsort.changes.subscribe((res: QueryList<MatSort>) => {
      if (res.first) {
        this.dataSource.sort = res.first;
        this.dataSource.sortingDataAccessor = (data: AdminConfig, headerId: string) => {
          switch (headerId) {
            case 'Version':
              return data.conseilConfig?.version ?? 0;
            case 'Enveloppe':
              return data.conditionsOfApplicability?.enveloppe?.libelle ?? '';
            case 'Habilitation':
              return data.conditionsOfApplicability?.habilitation?.libelle ?? '';
            case 'Type':
              return data.type;
            case 'Statut':
              return data.conseilConfig?.statut ?? '';
            case 'Mise à jour':
              return data.conseilConfig?.lastChangeDate ?? '';
            default:
              return '';
          }
        };
      }
    });
  }
  rowClick(selectedConfig: AdminConfig) {
    this.onRowClick.emit(selectedConfig);
  }

  displayColumnInfo(column: FicheConfigColumn, config: AdminConfig) {
    return column.getDataFromFicheConfig(config, this.datePipe);
  }
}
